<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { FilterUser } from '@/models/filter/FilterUser'
import AdminUserFilter from '@/components/admin/user/AdminUserFilter.vue'
import { AloDbUser } from '@/models/alodb/AloDbUser'

@Component({
  name: 'AdminUserList',
  components: {AdminUserFilter}
})

export default class AdminUserList extends AdminList<AloDbUser> {  
    
  get itemTypeName() {
    return "User"
  }

  get items()  {             
    return this.$store.myGetters.users.filter(u => 
      (this.filter.search.length == 0 ||  u.searchString!.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1) &&
      (this.filter.enseigneIds.length == 0 || this.filter.enseigneIds.indexOf(u.ENS_ID!) > -1) &&
      (this.filter.roleKeys.length == 0 || this.filter.roleKeys.some(r => u.ROLES?.some(ro => ro == r)))
    )    
  }

  get componentFilterName() {
    return 'AdminUserFilter'
  }
 
  get filter(){
    return this.$store.myGetters.adminUserFilter
  }

  get nbFiltre() {    
    return this.filter.enseigneIds.length + (this.filter.search.length > 0?1:0)
  }

  resetFilter() {
    this.$store.myActions.USER_UPDATE_FILTER_ADM(new FilterUser())
  }
}
</script>